/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/common/material/material-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColorPickerModule } from 'src/app/common/color-picker/color-picker.module';
import { ListItemComponent } from './components/list-item.component';
import { DialogTitlebarComponent } from './components/dialog-titlebar.component';
import { ItemListComponent } from './components/item-list.component';
import { AutomationIdDirective } from '../../shared/directives/automation-id/automation-id.directive';

@NgModule({
	declarations: [ListItemComponent, DialogTitlebarComponent, ItemListComponent],
	imports: [
		CommonModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		ColorPickerModule,
		AutomationIdDirective,
	],
	providers: [],
	exports: [DialogTitlebarComponent, ListItemComponent, ItemListComponent],
})
export class DialogReusableModule {}

export * from './components/abstract-item-list-editor.component';
export * from './components/abstract-add-edit-item.component';
export * from './interfaces/IButtonPanelEventData';
export * from './interfaces/IListItemData';
export * from './interfaces/IListItemEventData';
export * from './interfaces/IListItemFormEventData';
export * from './interfaces/IListItemDef';
export * from './interfaces/IListItemFilterDef';
